// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__rzPc9","navbarTitle":"Navbar_navbarTitle__xZp4N","navbarButton":"Navbar_navbarButton__-U5dW","navbarLink":"Navbar_navbarLink__iSe2P"};